// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"1c986519","615":"25436e8c","723":"c1eb93d5","787":"139d0a97","879":"9beace82"}[chunkId] + ".chunk.js";
};